import script from "./HorizontalPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HorizontalPanel.vue?vue&type=script&setup=true&lang=ts"

import "./HorizontalPanel.vue?vue&type=style&index=0&id=825616da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-825616da"]])

export default __exports__